import { render, staticRenderFns } from "./AppReviewableList.vue?vue&type=template&id=4484bc72&scoped=true&"
import script from "./AppReviewableList.vue?vue&type=script&lang=js&"
export * from "./AppReviewableList.vue?vue&type=script&lang=js&"
import style0 from "./AppReviewableList.vue?vue&type=style&index=0&id=4484bc72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484bc72",
  null
  
)

export default component.exports